import React, { memo } from 'react'
import { Title } from '@winnin/winnin_ui.components.title'

import EmptyBoardIllustration from '../../assets/images/svg/empty-video-board.svg'
import './index.scss'

const defaultHeader = 'No videos to show'
const defaultText = 'Try other filters or use a different date range to see more content'
const defaultIllustration = EmptyBoardIllustration

const EmptyState = memo(({ headerText = defaultHeader, text = defaultText, illustration = defaultIllustration }) => (
  <div className="empty-state">
    <img className="illustration" src={illustration} alt="" />
    <div className="message">
      <Title tag="h3" weight="bold" className="title">
        {headerText}
      </Title>
      <p>{text}</p>
    </div>
  </div>
))

export default EmptyState
